import controller from './kform-builder-option-inputs-label-position.controller';
import template from './kform-builder-option-inputs-label-position.html';

const kformBuilderOptionInputsLabelPositionDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionInputsLabelPositionDirective;
